import { connect } from 'react-redux';
import ScribeMainSidebar from './ScribeMainSidebar';
import {
  clearScribeConversationState,
  firebaseLogout,
  getTranscriptHtml,
  getTranscriptText,
  reconnectToWebSocket,
  switchLang,
  switchMultiEditOnWeb,
  switchPlatform,
  switchWebProduct,
  toggleAudioMode,
  toggleDevMode,
  toggleSideBar,
  updateFullScreen,
} from '../../actions';

const mapStateToProps = ({
  scribeConversation: {
    conversationStarted,
    inTwilioCalls,
    isInConversation,
    lang,
    langs,
    muted,
    scribe,
    status,
  },
  scribeSession: {
    activeFeatures,
    avaId,
    conversations,
    backends,
    captioner,
    currentPlatform,
    displayable,
    features,
    intercomDisplayed,
    mirror,
    scribeDashboard,
    subscription,
    v1,
  },
  firebase: { user },
  scribeTranscriptUI: { fullScreen },
}) => ({
  activeFeatures,
  avaId,
  conversations,
  backends,
  conversationStarted,
  currentPlatform,
  displayable,
  features,
  firebaseUser: user,
  fullScreen,
  intercomDisplayed,
  inTwilioCalls,
  isInConversation,
  lang,
  langs,
  mirror,
  muted,
  scribe,
  scribeDashboard,
  subscription,
  status,
  user: captioner,
  v1,
});

export default connect(
  mapStateToProps,
  {
    clearScribeConversationState,
    firebaseLogout,
    getTranscriptHtml,
    getTranscriptText,
    reconnectToWebSocket,
    switchLang,
    switchMultiEditOnWeb,
    switchPlatform,
    switchWebProduct,
    toggleAudioMode,
    toggleDevMode,
    toggleSideBar,
    updateFullScreen,
  }
)(ScribeMainSidebar);
